import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectTimezoneComponent } from './select-timezone.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [SelectTimezoneComponent],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule.forChild({}), SvgIconModule],
  exports: [SelectTimezoneComponent],
})
export class SelectTimezoneModule {}
